<template>
  <div class="add-location-page">
    <span v-if="isAdd" @click="finish">
      <Close  icon="close" />
    </span>
    <router-link v-else :to="`/${$getState('from')}`">
      <Close icon="close" />
    </router-link>
    <div class="title px30">
      <span v-html="title"/>
    </div>

    <!-- Location Card -->
    <div class="location-card">
      <div class="inner-container">

        <LocationSearch v-if="!isAdd" @set-location-form="setLocationForm" />

        <UseMyLocation class="mb-4" :route="isAdd" />

        <div class="divider"></div>
        
        <SavedLocations 
          v-if="!isAdd && filteredLocations.length"
          :locations="filteredLocations"
          @edit-location="editLocation"
          @remove-location="setConfirmModal" />

        <LocationForm
          v-if="isAdd"
          :form="form"
          @save-form="form=$event" />

        <ConfirmModal
          @yes="removeLocation"
          @no="close" />


        <div class="mt-8 pb-5">
          <Button type="button" :text="buttonText" :clickHandler="clickHandler" />
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
import Close from '../components/UI/Close.vue'
import LocationSearch from '../components/Location/LocationSearch.vue'
import UseMyLocation from '../components/Location/UseMyLocation.vue'
import SavedLocations from '../components/Location/SavedLocations.vue'
import LocationForm from '../components/Location/LocationForm.vue'
import Button from '../components/UI/Button.vue'
import ConfirmModal from '../components/Modal/ConfirmModal.vue'

export default {
  components: {
    Close,
    LocationSearch,
    UseMyLocation,
    SavedLocations,
    LocationForm,
    Button,
    ConfirmModal
  },
  created () {
    this.$store.commit('saveTagsForUserLocation')
    this.fetchSavedLocations()
  },
  data () {
    return {
      isAdd: false,
      form: null,
      toEditForm: null,
      savedLocations: []
    }
  },
  computed: {
    title () {
      let str = '<span class="text-primary">Select</span> <span class="text-secondary">Location</span>'
      if(this.isAdd) {
        str = `<span class="text-primary">${this.form && this.form.id ? 'Update' : 'Add a New'}</span> <span class="text-secondary">Address</span>`
      } 
      return str
    },
    buttonText () {
      return this.isAdd ? 'Done' : 'Add a New Address'
    },
    filteredLocations () {
      return this.savedLocations
    },
    isSame () {
      // if user enters the same address which is editing (after removing it)
      return this.toEditForm.address != this.form.address 
    }
  },
  methods: {
    async fetchSavedLocations() {
      const response = await this.$http.get('user/address')
      this.savedLocations = response.data
    },
    async clickHandler () {
      if(this.form && this.isAdd) {
        const obj = this.savedLocations.find(sl => sl.address == this.form.address)
        let response
        if(obj && obj.id && this.isSame) {
          this.form.id && this.removeLocation() // if user add current location in EDIT MODE, then remove editing loca & update the new one
          response = await this.$http.put(`user/address/${obj.id}`, this.form)
        } else {
          response = this.form && this.form.id ? await this.$http.put(`user/address/${this.form.id}`, this.form) : await this.$http.post('user/address', this.form)
        }
        this.$setState('setIsCurrent', false)
        response.status && this.finish()
      }
      else {
        this.isAdd = true
      }
    },
    editLocation (data) {
      this.isAdd = true 
      this.form = { ...data }
      this.toEditForm = { ...data }
    },
    setConfirmModal (data) {
      this.form = data
      this.$store.commit('setConfirmModal', true)
    },
    async removeLocation () {
      const response = await this.$http.delete(`user/address/${this.form.id}`)
      if(response.status) {
        this.$setState("setAnotherLocation", null)
        this.fetchSavedLocations()
        this.close()
      }
    },
    finish () {
      this.form = null
      this.isAdd = false
      this.$setState('setIsCurrent', false)
      this.fetchSavedLocations()
    },
    close () {
      this.form = null
      this.$setState('load', 0)
      this.$store.commit('setConfirmModal', false)
    },
    setLocationForm (data) {
      this.isAdd = true
      this.form = data
    }
  }
}
</script>